import {CAMPAIGN_SYSTEM_USER_MESSAGE_PREFIX} from './systemChatMessages';

export const CAMPAIGN_WIDGET_TOOL_NAMES = {
  QUANTIDADE_ARTES: 'solicitar_quantidade_artes',
  IMAGENS_CAMPANHA: 'solicitar_imagens_campanha',
  APROVACAO_ESTRATEGIA: 'solicitar_aprovacao_estrategia',
  APROVACAO_ARTES: 'solicitar_aprovacao_artes',
  MODO_CONCLUSAO: 'solicitar_modo_conclusao',
  REDES_SOCIAIS: 'solicitar_redes_sociais',
  CONFIGURAR_AGENDAMENTO: 'configurar_agendamento',
  CONFIRMAR_EDICAO_LOTE: 'confirmar_edicao_lote_artes',
  CONFIRMAR_REJEICAO_LOTE: 'confirmar_rejeicao_lote_artes',
  ACOES_FINAIS: 'solicitar_acoes_finais',
  EXECUTAR_AGENDAMENTO: 'executar_agendamento',
  EDITAR_ARTES_LOTE: 'editar_artes_lote',
  FINALIZAR_CAMPANHA: 'finalizar_campanha',
};

/** Canonical action button types for Campaign Chat (aligned with backend FinalAction). */
export const ACTION_TYPES = {
  SELECT_PLAN: 'select_plan',
  NEW_CAMPAIGN: 'new_campaign',
  CONFIRM_BATCH_EDIT: 'confirm_batch_edit',
  CANCEL_BATCH_EDIT: 'cancel_batch_edit',
  FINISH: 'FINISH',
};

export function buildCampaignCompletionMessage(suffix) {
  return `${CAMPAIGN_SYSTEM_USER_MESSAGE_PREFIX} ${suffix}`;
}

export function buildPostQuantityCompletionMessage(quantity) {
  return buildCampaignCompletionMessage(`quantidade_artes ${quantity}`);
}

export function buildImagesCompletionMessage(imageUrls) {
  return buildCampaignCompletionMessage(
    `imagens_campanha ${JSON.stringify(imageUrls)}`,
  );
}

export function buildStrategyApprovalCompletionMessage(action) {
  return buildCampaignCompletionMessage(`aprovacao_estrategia ${action}`);
}

export function buildArtsApprovalCompletionMessage(action) {
  return buildCampaignCompletionMessage(`aprovacao_artes ${action}`);
}

export function buildCompletionModeMessage(mode) {
  return buildCampaignCompletionMessage(`modo_conclusao ${mode}`);
}

export function buildSocialNetworksCompletionMessage(networksOrSelection) {
  if (
    Array.isArray(networksOrSelection) &&
    networksOrSelection.length > 0 &&
    typeof networksOrSelection[0] === 'object' &&
    networksOrSelection[0] !== null
  ) {
    return buildCampaignCompletionMessage(
      `redes_sociais ${JSON.stringify(networksOrSelection)}`,
    );
  }

  const networks = Array.isArray(networksOrSelection) ? networksOrSelection : [];
  return buildCampaignCompletionMessage(`redes_sociais ${networks.join(',')}`);
}

export function buildScheduleConfigCompletionMessage(arts) {
  return buildCampaignCompletionMessage(
    `agendamento_configurado ${JSON.stringify(arts)}`,
  );
}

export function buildBatchEditConfirmMessage(confirmed) {
  return buildCampaignCompletionMessage(
    `confirmar_edicao_lote ${confirmed ? 'CONFIRM' : 'CANCEL'}`,
  );
}

export function buildBatchRejectConfirmMessage(confirmed) {
  return buildCampaignCompletionMessage(
    `confirmar_rejeicao_lote ${confirmed ? 'CONFIRM' : 'CANCEL'}`,
  );
}

export function buildFinalActionCompletionMessage(action) {
  return buildCampaignCompletionMessage(`acao_final ${action}`);
}

export function mapApprovalAction(type) {
  if (
    type === 'approve' ||
    type === 'approve_strategy' ||
    type === 'approve_arts'
  ) {
    return 'APPROVED';
  }
  if (type === 'edit' || type === 'batch_edit') return 'EDIT';
  if (type === 'reject') return 'REJECT';
  return null;
}

export function mapCompletionModeAction(type) {
  if (type === 'schedule_option') return 'SCHEDULE';
  if (type === 'finalize_campaign') return 'FINALIZE';
  return null;
}

export function mapBatchEditAction(type) {
  if (type === ACTION_TYPES.CONFIRM_BATCH_EDIT) return 'CONFIRM';
  if (type === ACTION_TYPES.CANCEL_BATCH_EDIT) return 'CANCEL';
  return null;
}

export function mapBatchRejectAction(type) {
  if (type === ACTION_TYPES.CONFIRM_BATCH_EDIT) return 'CONFIRM';
  if (type === ACTION_TYPES.CANCEL_BATCH_EDIT) return 'CANCEL';
  return null;
}

export function mapFinalAction(type) {
  if (type === ACTION_TYPES.SELECT_PLAN) return 'SELECT_PLAN';
  if (type === ACTION_TYPES.NEW_CAMPAIGN) return 'NEW_CAMPAIGN';
  if (type === ACTION_TYPES.FINISH) return 'FINISH';
  return null;
}

export const STRATEGY_APPROVAL_OPTIONS = [
  {type: 'approve_strategy'},
  {type: 'edit'},
  {type: 'reject'},
];

export const ARTS_APPROVAL_OPTIONS = [
  {type: 'approve_arts'},
  {type: 'batch_edit'},
  {type: 'reject'},
];

export const COMPLETION_MODE_OPTIONS = [
  {type: 'schedule_option', name: 'Agendar publicações'},
  {type: 'finalize_campaign', name: 'Finalizar campanha'},
];

export const BATCH_EDIT_CONFIRM_OPTIONS = [
  {type: ACTION_TYPES.CONFIRM_BATCH_EDIT},
  {type: ACTION_TYPES.CANCEL_BATCH_EDIT},
];

export const BATCH_REJECT_CONFIRM_OPTIONS = [
  {type: ACTION_TYPES.CONFIRM_BATCH_EDIT},
  {type: ACTION_TYPES.CANCEL_BATCH_EDIT},
];

export const FINAL_ACTION_OPTIONS = [
  {type: ACTION_TYPES.SELECT_PLAN},
  {type: ACTION_TYPES.NEW_CAMPAIGN},
  {type: ACTION_TYPES.FINISH, name: 'Finalizar'},
];
